"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcSwitchBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_switch_constants_1 = require("./bc-switch-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var BcSwitchBehavior = (function (_super) {
    __extends(BcSwitchBehavior, _super);
    function BcSwitchBehavior() {
        var _this = _super.call(this) || this;
        _this.isChecked = false;
        _this.isEnabled = true;
        _this.switchLabel = null;
        return _this;
    }
    BcSwitchBehavior.setUpAll = function () {
        var checkboxElements = Array.from(document.querySelectorAll("[class^='".concat(bc_switch_constants_1.BcSwitchConstants.BC_SWITCH_CONTAINER_CLASS, "']:not([configured])")));
        return checkboxElements.map(function (element) {
            var bc = new BcSwitchBehavior();
            bc.setElement(element);
            bc.setUp();
            return bc;
        });
    };
    BcSwitchBehavior.prototype._setUp = function () {
        this.switchLabel = this.getMySelf();
        this._setStyles();
        this._setAccesibility();
        this._setMouseEvents();
        this._setKeyboardEvents();
    };
    BcSwitchBehavior.prototype._setStyles = function () {
        var inputIsDisabled = this.switchLabel.querySelector('input').hasAttribute('disabled');
        this.switchLabel.toggleAttribute('disabled', inputIsDisabled);
    };
    BcSwitchBehavior.prototype._setAccesibility = function () {
        if (this.switchLabel.querySelector('input').checked) {
            this.isChecked = true;
        }
        if (this.switchLabel.querySelector('input').hasAttribute('disabled')) {
            this.isEnabled = false;
            this.switchLabel.setAttribute('tabindex', '-1');
            this.switchLabel.setAttribute('aria-disabled', 'true');
            this.switchLabel.querySelector('span').classList.add('disabled');
        }
        else {
            this.isEnabled = true;
            this.switchLabel.setAttribute('tabindex', '0');
            this.switchLabel.querySelector('span').classList.remove('disabled');
            this.switchLabel.setAttribute('aria-disabled', 'false');
        }
        this.switchLabel.setAttribute('role', 'switch');
        this._setAriaAttributes();
    };
    BcSwitchBehavior.prototype.changeValue = function (state) {
        this.isChecked = state;
        this._setAriaAttributes();
    };
    BcSwitchBehavior.prototype.enable = function (enabled) {
        this.isEnabled = enabled;
        if (!this.isEnabled) {
            this.switchLabel.querySelector('input').setAttribute('disabled', 'disabled');
            this.switchLabel.toggleAttribute('disabled', true);
            this.switchLabel.querySelector('span').classList.add('disabled');
            this.switchLabel.setAttribute('tabindex', '-1');
        }
        else {
            this.switchLabel.querySelector('input').removeAttribute('disabled');
            this.switchLabel.toggleAttribute('disabled', false);
            this.switchLabel.setAttribute('tabindex', '0');
            this.switchLabel.querySelector('span').classList.remove('disabled');
        }
    };
    BcSwitchBehavior.prototype.toggle = function () {
        this.isChecked = !this.isChecked;
        this._setAriaAttributes();
    };
    BcSwitchBehavior.prototype._setAriaAttributes = function () {
        this.switchLabel.setAttribute('aria-checked', "".concat(this.isChecked));
    };
    BcSwitchBehavior.prototype._setMouseEvents = function () {
        var _this = this;
        var inputElement = this.switchLabel.querySelector('input');
        inputElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            if (_this.isEnabled) {
                _this.toggle();
            }
        });
    };
    BcSwitchBehavior.prototype._setKeyboardEvents = function () {
        var _this = this;
        this.switchLabel.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE || event.code === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                _this.isEnabled = !_this.switchLabel.querySelector('input').hasAttribute('disabled');
                if (_this.isEnabled) {
                    _this.switchLabel.querySelector('input').dispatchEvent(new Event(common_constants_1.BcCommonConstants.EVENT_CLICK));
                    _this.switchLabel.querySelector('input').checked = _this.isChecked;
                }
                event.preventDefault();
            }
        });
    };
    return BcSwitchBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcSwitchBehavior = BcSwitchBehavior;
